import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    private abort = new AbortController();

    connect(): void {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        document.addEventListener("click", this.keepEmbedded, { capture: true, signal });
        document.addEventListener("submit", this.keepEmbedded, { capture: true, signal });
        document.addEventListener("htmx:configRequest", this.configureRequest, { signal });
    }

    disconnect(): void { this.abort.abort(); }

    private keepEmbedded = (event: Event): void => {
        if (!(event.target instanceof Element)) return;
        const link = event.target.closest<HTMLAnchorElement>("a[href]");
        const form = event.target.closest<HTMLFormElement>("form");
        const target = link ?? form;
        if (!target || (link && link.target === "_blank")) return;
        const url = new URL(link ? link.href : form!.action, window.location.href);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set("embed", "1");
        if (link) {
            link.href = url.href;
            const pushUrl = link.getAttribute("hx-push-url");
            if (pushUrl && pushUrl !== "true" && pushUrl !== "false") {
                const historyUrl = new URL(pushUrl, window.location.href);
                if (historyUrl.origin === window.location.origin) {
                    historyUrl.searchParams.set("embed", "1");
                    link.setAttribute("hx-push-url", historyUrl.pathname + historyUrl.search);
                }
            }
        }
        else form!.action = url.href;
    };

    private configureRequest = (event: Event): void => {
        const detail = (event as CustomEvent<{ path: string }>).detail;
        const url = new URL(detail.path, window.location.href);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set("embed", "1");
        detail.path = url.pathname + url.search;
    };

    async requestStorage(): Promise<void> {
        try {
            if (typeof document.requestStorageAccess === "function") {
                await document.requestStorageAccess();
                window.location.reload();
            }
        } catch {
            const status = this.element.querySelector<HTMLElement>("[data-crm-storage-status]");
            if (status) status.textContent = "Ouvrez Elron dans un nouvel onglet pour vous connecter, puis revenez ici et réessayez.";
        }
    }
}
